import { useEffect, useState } from "react";
import { navLinks, siteName } from "@/mocks/home";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={[
        "fixed inset-x-0 top-0 z-50 w-full transition-all duration-300",
        scrolled
          ? "border-b border-background-200/70 bg-background-50/90 backdrop-blur"
          : "border-b border-transparent bg-transparent",
      ].join(" ")}
    >
      <nav className="flex w-full items-center justify-between px-4 py-3 md:px-8 md:py-4">
        <a href="#top" className="flex items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
            <i className="ri-film-line text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              {siteName}
            </span>
            <span className="mt-1 text-[10px] font-medium tracking-[0.3em] text-secondary-700">
              专题合集
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.id}
              href={`#${link.id}`}
              className="group flex items-center gap-1.5 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-foreground-950"
            >
              <span className="text-[10px] font-semibold tracking-wider text-accent-500">
                {link.num}
              </span>
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#resource"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950 sm:block"
          >
            进入观看
          </a>
          <button
            type="button"
            aria-label="展开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </nav>

      {open ? (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={() => setOpen(false)}
                className="flex items-center gap-3 rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-100"
              >
                <span className="text-[10px] font-semibold tracking-wider text-accent-500">
                  {link.num}
                </span>
                {link.label}
              </a>
            ))}
            <a
              href="#resource"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-center text-sm font-medium text-background-50"
            >
              进入观看
            </a>
          </div>
        </div>
      ) : null}
    </header>
  );
}